var map = {
	"./img-no1.png": "ExsE",
	"./img-no2.png": "nNCD",
	"./img-no3.png": "ogBt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "itA7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping ^\.\/img\-no.*\.png$
// module id = itA7
// module chunks = 0